'use client'
import React, {useCallback, useMemo, useState} from 'react';
import { header, optionsMap } from 'src/views/abi/fields/create-entry-summary';
import SnackBar from 'src/components/era-package/era/SnackBar';
import { Button } from '@mui/material';
import { Link } from 'react-router-dom'
import pathMap from 'src/paths/pathMap';
import { generatePath } from 'react-router-dom/cjs/react-router-dom';
import RenderFormWithRHF from 'src/components/era-package/forms/RenderFormWithRHF';
import AbiEntrySummaryApiUrls from "../../../../apiUrls/AbiEntrySummaryApiUrls";

const CreateEntrySummary = ({ history }) => {
  const [showSuccessSnackbar, setShowSuccessSnackbar] = useState(false)
  const [showErrorSnackbar, setShowErrorSnackbar] = useState(false);

  // Set up form sections including table sections
  const formSections = useMemo(
    () => [
      {
        fields: header,
        headless: true,
        disableGutters: true
      },
    ],
    [],
  );

  // Set up form data
  const allFields = useMemo(
    () => formSections.flatMap((section) => section.fields),
    [formSections], // Make sure to update the dependency array
  );


  const handleFormSuccess = async (formData) => {
    console.log(formData)
    try {
      const response = await fetch(AbiEntrySummaryApiUrls.POST, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('userToken'))
        },
        body: JSON.stringify(formData)  // Convert JS object to JSON string
      });

      if (!response.ok) {
        setShowErrorSnackbar(true);
        throw new Error('Failed to submit form');
      }

      const result = await response.json();
      console.log('Form submitted successfully:', result);
      console.log('ABI Trans ID: ', result.data.abiTransId);
      setShowSuccessSnackbar(result.data.abiTransId)
    } catch (error) {
      setShowErrorSnackbar(true);
      console.error('Error submitting form:', error);
    }
  }
  const handleSuccessSnackbarClose = (e, reason) => {
    console.log("abi id: " + showSuccessSnackbar);
    if (reason === 'timeout') {
      history.push(pathMap.ABI_ENTRY_SUMMARY_EDIT_VIEW.replace(':id', showSuccessSnackbar))
      setShowSuccessSnackbar(false)
    }
  }

  // Handle error snackbar close
  const handleErrorSnackbarClose = useCallback(() => {
    setShowErrorSnackbar(false);
  }, []);

  return (<>
    <RenderFormWithRHF
      title="Create Entry Summary"
      formSections={formSections}
      allFields={allFields}
      optionsMap={optionsMap}
      submitLabel="Create"
      onSubmit={handleFormSuccess}
      sx={{ border: 0 }}
      formConfig={{

      }}
    />

    <SnackBar
      title="Form submitted successfully"
      type="success"
      open={!!showSuccessSnackbar}
      onClose={handleSuccessSnackbarClose}
      duration={3000}
    >
      Redirecting to Entry Summary...
    </SnackBar>

    {/* Error Snackbar - Only show when showErrorSnackbar is true */}
    <SnackBar
        title="Form Submittion Error"
        type="error"
        open={showErrorSnackbar}
        onClose={handleErrorSnackbarClose}
        duration={10000}
    >
      Internal error occured, please try again later.
    </SnackBar>
  </>);
};

export default CreateEntrySummary;
